<template>
  <div>
    <div
      :class="
        selectedProduct && !isDesktop
          ? 'add-dish-container block-scroll blur-bg'
          : 'add-dish-container'
      "
    >
      <div v-if="selectedProduct" class="hide-content" @click="uiCancel"></div>
      <div class="wrapper">
        <!-- <h4 class="choose-dish">{{ $t('add_dish.title') }}</h4> -->
        <div class="product-blocks" v-for="cat in nonEmptyCategories">
          <small>{{ cat.name }}</small>
          <div
            class="product-block"
            v-for="product in categoryProducts(cat)"
            @click="selectProduct(product)"
          >
            <img :src="product.image ? product.image : '/icons/no-dish.jpg'" />
            <p>{{ product.name }}</p>
          </div>

          <!-- <div class="actions" v-if="false">
      <QueueButton variant="cancel" @click="uiCancel">{{ $t('add_dish.back') }}</QueueButton>
      <QueueButton
        variant="accept"
        class="float-right"
        :disabled="!canAddToCart"
        @click="uiContinue"
      >{{ $t('add_dish.add') }}</QueueButton>
    </div>-->
        </div>

        

        <NavbarDesktop
          v-if="editing_order && isDesktop"
          @onDiscardAction="goBack"
          @onConfirmAction="confirmFromDesktop"
          :cart="pending_items.length"
          :addToCart="!selectedProduct && pending_items.length ? true : false"
          :action="{
            type: selectedProduct ? 'product-selected' : 'selectDish',
          }"
        />
      </div>

<div v-if="selectedProduct" class="dish-options">
          <h5>{{ currentProduct.name }}</h5>
          <div
            class="price-group-container"
            v-for="(group, group_index) in selectedProduct.price_groups"
            :key="group_index"
          >
            <div class="variant" v-if="group.single_select">
              <span class="p-0 c-grey">
                {{ group.name || $t("add_dish.choose_variant") }}
              </span>
              <div
                class="form-circle-box"
                v-for="item in group.items"
                @click="selectVariant(item, group)"
              >
                <div
                  :class="
                    isVariantSelected(item)
                      ? 'circle-option active'
                      : 'circle-option'
                  "
                ></div>
                <span>{{ item.name }}</span>
              </div>
            </div>
            <div v-else>
              <span class="p-0 c-grey">
                {{ group.name || $t("add_dish.choose_modificators") }}
              </span>
              <div
                class="form-square-box"
                v-for="mod in group.items"
                @click="selectModificator(mod)"
              >
                <div
                  :class="
                    isModificatorExisting(mod)
                      ? 'square-option active'
                      : 'square-option'
                  "
                ></div>
                <span>{{ mod.name }}</span>
              </div>
            </div>
          </div>

          <br />
          <div class="amount">
            <img
              src="/icons/btn-minus.svg"
              class="btn-dec"
              @click="decDish()"
            />

            <span class="text-center d-block w-100"
              >{{ formattedQuantity }}</span
            >

            <img src="/icons/btn-plus.svg" class="btn-inc" @click="incDish()" />
          </div>

          <!-- <button class="add-to-cart" v-if="cart" @click="uiContinue">{{ $t('add_dish.add_to_cart') }}</button> -->
        </div>

    </div>
    <div class="fixed-wrapper" v-if="editing_order && !isDesktop">
      <img
        src="/icons/btn-back.svg"
        @click="goBack"
        class="action-cancel-button no-space"
      />

      <small class="info" v-if="!selectedProduct && !pending_items.length"
        >{{ $t('create_order.choose_dish') }}</small
      >

      <button class="add-to-cart" v-if="selectedProduct" @click="uiContinue">
        {{ $t("add_dish.add_to_cart") }}
      </button>

      <button
        class="add-to-cart"
        v-if="!selectedProduct && pending_items.length"
        @click="emitAddMany"
      >
        {{ $t("add_dish.add_many") }}
        <span>(+{{ pending_items.length }})</span>
      </button>
    </div>
  </div>
</template>

<script>
import QueueButton from "@/components/QueueButton.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";

export default {
  props: {
    cart: {
      type: Boolean,
      default: false,
    },
    editing_order: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stage: "categories",

      selectedCategory: null,
      selectedProduct: null,

      currentProduct: {
        name: null,
        variant: null,
        variants: [],
        quantity: 1,
        modificators: [],
      },

      pending_items: [],

      dish_modal_shown_at: Date.now()
    };
  },
  watch: {
    pending_items() {
      this.$emit("setCart", this.pending_items.length);
    },
  },
  methods: {
    //UI
    uiContinue() {
      const new_item = Object.assign(
        {},
        {
          name: this.currentProduct.name,
          category: this.selectedProduct.category,
          variant: this.currentProduct.variants.length
            ? this.currentProduct.variants.map((i) => i.name).join(",")
            : null,
          quantity: this.currentProduct.quantity,
          variants: this.currentProduct.variants,
          price: this.selectedProductPrice,
          modificators: this.currentProduct.modificators,
          weight: this.selectedProduct.base_weight,
          weight_flag: this.selectedProduct.weight_flag,
          unit: this.selectedProduct.unit,
          total_weight: this.selectedProduct.weight_flag == 1 ? this.selectedProduct.base_weight * this.currentProduct.quantity : this.selectedProduct.base_weight,
          available: true,
        }
      );

      if (this.editing_order) {
        this.pending_items.push(new_item);

      } else {
        this.$emit("add", new_item);
      }

      window.document.body.style.position = "initial";
      this.selectedProduct = null;

      this.$emit("select", false);
    },
    uiCancel() {
      if (Date.now() - this.dish_modal_shown_at < 300) return;

      window.document.body.style.position = "initial";
      this.selectedProduct = null;

      this.$emit("select", false);
    },

    goBack() {
      if (this.selectedProduct) {
        this.uiCancel();
      } else {
        this.$emit("close");
      }
    },
    emitAddMany() {
      this.$emit("addMany", this.pending_items);
      this.$emit("close");
    },

    //Handlers
    selectCategory(categoryName) {
      this.selectedCategory = categoryName;
      this.stage = "products";
    },
    selectProduct(p) {
      this.selectedProduct = p;
      this.$emit("select", true);
      
      window.document.body.style.position = "fixed";
      window.document.body.style.left = "0";
      window.document.body.style.right = "0";
      this.currentProduct.name = p.name;
      this.currentProduct.variant = null;
      this.currentProduct.modificators = [];
      this.currentProduct.quantity = 1;
      this.currentProduct.variants = [];

      this.selectedProduct.price_groups.forEach((pg) => {
        if (pg.single_select) {
          this.currentProduct.variants.push(pg.items[0]);
        }
      });

      this.dish_modal_shown_at = Date.now();
    },
    showOptions() {
      this.dishOptions = !this.dishOptions;
    },
    incDish() {
      if (this.currentProduct.quantity >= 30) return;

      this.currentProduct.quantity++;
    },
    categoryProducts(c) {
      return this.menu.products.filter((p) => p.category_id === c._id);
    },
    decDish() {
      if (this.currentProduct.quantity <= 1) return;

      this.currentProduct.quantity--;
    },
    selectOption(price) {
      this.currentProduct.variant = price;
    },
    selectModificator(mod) {
      const existing = this.currentProduct.modificators.findIndex(
        (item) => item.name == mod.name
      );
      if (existing == -1) {
        this.currentProduct.modificators.push(mod);
      } else {
        this.currentProduct.modificators.splice(existing, 1);
      }
    },
    isModificatorExisting(mod) {
      return (
        this.currentProduct.modificators.findIndex(
          (item) => item.name == mod.name
        ) !== -1
      );
    },
    isVariantSelected(mod) {
      return (
        this.currentProduct.variants.findIndex(
          (item) => item.name == mod.name
        ) !== -1
      );
    },
    selectVariant(item, group) {
      group.items.forEach((item) => {
        this.currentProduct.variants = this.currentProduct.variants.filter(
          (v) => v.name != item.name
        );
      });

      this.currentProduct.variants.push(item);
    },
    confirmFromDesktop() {
      if (!this.selectedProduct && this.pending_items.length) {
        this.emitAddMany();
      } else this.uiContinue();
    },
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    products() {
      return this.menu.products.filter(
        (p) => p.category === this.selectedCategory
      );
    },
    canAddToCart() {
      return this.stage === "products" && !!this.currentProduct.name;
    },
    menu() {
      return this.$store.state.menu;
    },
    selectedProductPrice() {
      let price = this.selectedProduct.base_price || 0;

      this.currentProduct.variants.map((v) => (price += v.price));

      return price;
    },
    nonEmptyCategories() {
      return this.menu.categories.filter(c => {
        return !!this.menu.products.find(p => p.category_id == c._id);
      });
    },
    formattedQuantity() {
      if (!this.currentProduct) return 0;

      if (this.selectedProduct.weight_flag == 1) {
        const item_weight = this.currentProduct.quantity * this.selectedProduct.base_weight;
        return `${item_weight} ${this.$t('units.'+this.selectedProduct.unit)}`;
      } else {
        return `${this.currentProduct.quantity}x`;
      }
    }
  },
  components: { QueueButton, NavbarDesktop },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}

.hide-content {
  height: 100%;
  width: 100%;
  position: fixed;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  opacity: 1;
  z-index: 5;
  top: 0;
  left: 0;
}

.price-group-container {
  padding-top: 2.5vh;
}

.add-to-cart {
  display: block;
  background: #129b81;
  font-size: 4.3vw;
  padding: 1vh 0;
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  border: none;
  color: white;
  width: 70vw;
}

.add-dish-container {
    padding-bottom: 25vh;
    z-index: 2;
    left: 0;
    top: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8vh 0 5vh;
    background: #ededed;
    width: 100%;  
}

.block-scroll {
  position: fixed;
   overflow: hidden !important;
}

.fixed-wrapper {
  background: #1d1d1d;
  bottom: 0;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1.3vh 3.2vh 2.6vh;
  z-index: 5;
  width: 100%;
  position: fixed;
  left: 0;
}

.wrapper {
  padding-bottom: 5vh;
}

.form-circle-box,
.form-square-box {
  display: flex;
  padding-top: 1.1vh;
  align-items: center;
}

.form-circle-box span,
.form-square-box span {
  font-size: 2.3vh !important;
}

.circle-option {
  border-radius: 5vh;
  height: 3vh;
  width: 3vh;
  border: 1px solid #a4a3a1;
  background: transparent;
}

.square-option {
  border-radius: 0.8vh;
  width: 3vh;
  height: 3vh;
  border: 2px solid #a4a3a1;
  background: transparent;
}

.circle-option.active,
.square-option.active {
  background: #1d1d1b;
  border: none;
}

.blur-bg {
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  height: 100% !important;
}

.product-blocks small {
  color: #908f8d;
  font-size: 4.3vw;
  padding: 2.5vh 0 1.9vh;
  line-height: normal;
  width: 100%;
  display: block;
}

h4.choose-dish {
  padding-left: 5.4vw;
}

.product-blocks {
  display: flex;
  flex-flow: row wrap;
  overflow-x: hidden;
  margin: 0 auto;
  width: 86%;
  padding-bottom: 1.2vh;
  border-bottom: 1px solid #a4a3a1;
}

.product-block {
  display: flex;
  height: auto;
  margin: 0 0.1vh 1.2vh 0.1vh;
  overflow: hidden;
  justify-content: flex-start;
  align-content: flex-start;
  width: 32.5%;
  justify-content: flex-start;
  flex-flow: row wrap;
  line-height: normal;
}

.product-block:nth-child(3n + 2) {
  margin: 0.1vh 0.1vh 0;
}

.product-block p {
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.product-block:nth-child(3n + 2) {
  margin-bottom: 1.5vh;
}

.product-block img {
  width: 26.6vw;
  height: 26.6vw;
  border-radius: 10px;
  object-fit: cover;
}

.dish-options {
  overflow-y: scroll;
  overflow-x: hidden;
  position: fixed;
  max-height: 60vh;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  width: 90%;
  padding: 3.7vh;
  margin: 0 auto;
  z-index: 5;
  border:3px solid #1d1d1d;
  border-radius: 20px;
  background: #ededed;
}

.dish-options h5 {
  font-size: 2.7vh;
  color: #1d1d1b;
  line-height: normal;
  text-align: center;
}

.amount {
  display: flex;
  justify-content: space-between;
}

.btn-inc,
.btn-dec {
  width: auto;
  height: 6vh;
}

.dish-options span {
  font-size: 2.3vh;
  padding-left: 1.2vh;
}

.amount span {
  font-size: 3vh;
  line-height: 1.8;
  font-weight: 600;
}

.dish-props h5 {
  color: black;
  text-align: center;
  padding-top: 10px;
  font-size: 20px;
}

ul {
  padding: 0;
}

.custom-control-label::before {
  position: absolute;
  top: 3.5px;
  left: -25px;
  display: block;
  width: 1rem;
  padding: 8px;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}

.custom-contol-label::after {
  top: 5px;
  left: -24px;
}

.c-grey {
  color: #908f8d;
}

.variant span {
  font-size: 2.3vh;
  padding-left: 1.2vh;
}

.custom-control {
  padding: 1.3vh 6vw 0;
}

ul li {
  list-style-type: none;
  margin: 15px auto;
  font-weight: bold;
  padding: 7px 0;
  width: 90%;

  box-shadow: 0px 0px 40px #dddddd;
  border-radius: 40px;
}

li.active {
  border: 2px solid #129b81;
}

.actions {
  height: 110px;
  background: white;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 25px 17px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  position: fixed;
}

.create-order-buttons {
  background: #1d1d1d;
  bottom: 0;
  padding: 1.3vh 3.2vh 2.8vh;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: fixed;
  left: 0;
}

.btn-back {
  background: #e2223b;
  color: white;
  width: 6.2vh;
  height: 6.2vh;
  border-radius: 5vh;
  border: none;
}

.btn-back img {
  display: block;
  margin: 0 -0.5vh auto;
}

.btn-cart {
  background: #aeccc6;
  border-radius: 5vh;
  color: white;
  float: right;
  font-size: 2.3vh;
  color: #1d1d1d;
  height: auto;
  width: 80%;
  border: none;
}

.create-order-cart {
  width: 90vw;
  margin: 0 auto 22vh;
  top: 10vh;
  position: relative;
  background: #ededed;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  border: 1px solid #bcbcbc;
}

@media screen and (min-width: 768px) {
  .wrapper {
    padding-top: 5.556vw;
  }
  .wrapper::-webkit-scrollbar {
    width: 0;
  }
  div.create-order-buttons {
    display: none;
  }
  .add-dish-container {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    top: 0;
  }
  h4.choose-dish {
    display: none;
  }
  .product-blocks {
    width: 97.569vw;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: 1.181vw;
    padding: 0 2.569vw 0 1.389vw;
  }

  div.product-block {
    width: 6.944vw;
    margin-right: 1.042vw;
    display: flex;
    flex-direction: column;
  }
  .product-block:nth-child(3n + 2) {
    margin-right: 1.042vw;
  }
  .product-block img {
    width: 6.944vw;
    height: 6.944vw !important;
  }
  .product-block p {
    margin-top: 0.347vw;
    font-size: 0.833vw;
    line-height: 0.972vw;
  }
  .product-blocks small {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  div.dish-options {
    width: 22.569vw;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 2.083vw;
    box-sizing: border-box;
    border-radius: 1.389vw;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  div.dish-options h5 {
    font-size: 1.528vw;
    line-height: 1.736vw;
  }
  div.variant {
    display: flex;
    flex-direction: column;
  }
  div.price-group-container {
    padding-top: 1.389vw;
  }
  .p-0.c-grey {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  div.form-circle-box div.circle-option,
  div.form-square-box div.square-option {
    width: 1.458vw;
    height: 1.458vw;
  }

  div.form-circle-box span,
  div.form-square-box span {
    font-size: 1.042vw;
    line-height: 1.181vw;
  }
  div.hide-content {
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
  }
}
</style>
